import React, { PropsWithChildren } from 'react'
import { AvatarProps, Avatar as MuiAvatar, ThemeOptions } from '@mui/material'
import styled from '@emotion/styled'

const Avatar: React.FC< PropsWithChildren & AvatarProps> = ({ children, ...props }) => (
  <>
  {!props.src && <AltText>
    {props.alt}
  </AltText>}
  <MuiAvatar
    {...props}
  >
    {children}
  </MuiAvatar>
  </>
)

export { Avatar }

export type { AvatarProps }

export const avatarThemeOverrides: ThemeOptions['components'] = {
  MuiAvatar: {
    styleOverrides: {
      root: {
        color: 'rgba(0, 0, 0, 0.87)',
      },
    },
  },
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const AltText = styled.div`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`